import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-table-sortable', 'sortBy', 'Sorteeri');
Labels.set('ui-table-sortable', 'clickToSort', 'Klõpsa sorteerimiseks');
